<template>
  <div>
    <Topbar></Topbar>
    <SidePage></SidePage>
    <Guide></Guide>
  </div>
</template>
<script>
import { onMounted, onUnmounted, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { onWindowResize, offWindowResize } from '../module/win'
import Topbar from '../components/Topbar.vue'
import SidePage from '../components/SidePage.vue'
import Guide from '../components/Guide.vue'
export default {
  components: { Topbar, SidePage, Guide },
  setup () {
    const router = useRouter()
    const store = useStore()
    const obj =  reactive({
      windowWidth: 0,
      windowHeight: 0,
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      onWindowResize(callback)
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      offWindowResize()
    })

    // onWindowResize回调方法
    const callback = (windowWidth, windowHeight) => {
      obj.windowWidth = windowWidth
      obj.windowHeight = windowHeight
      store.state.myChart && store.state.myChart.resize() // 图表自适应
      // nextTick(() => {
      //   store.state.myChart && store.state.myChart.resize() // 图表自适应
      // })
      store.commit('setWindowHeight', obj.windowHeight) // 储存窗口高度
      store.commit('setWindowWidth', obj.windowWidth) // 储存窗口宽度
    }
  }
}
</script>
<style scoped>
</style>